export default "<p>default-page works!</p>\r\n"